<div id="input-dialog-component" fxLayout="column">
  <gt-dialog-header [message]="message" (closing)="cancelClicked()"></gt-dialog-header>

  <div mat-dialog-content fxLayout="column" style="min-width: 300px; margin-bottom: 12px">
    <div *ngIf="subheader" style="max-width: 900px;">{{ subheader | translate }}</div>

    <mat-form-field *ngIf="showInput">
      <input matInput name="inputDialogInput" [(ngModel)]="response" (keyup.enter)="okClicked()" />
    </mat-form-field>
  </div>

  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button *ngIf="!disableClose" mat-button id="cancel-button" (click)="cancelClicked()" color="primary">
      {{ 'global.cancel' | translate }}
    </button>
    <button mat-button id="ok-button" (click)="okClicked()" color="primary">{{ 'global.ok' | translate }}</button>
  </div>
</div>
